import { displayDate } from '../../lib/util'

const DATE_FORMAT = 'M/D/YYYY'
const NO_DATA_PLACEHOLDER = 'N/A'
const TOTAL_LESSONS = 27

export const createTrainingReportDownloadData = (
  trainingData,
  program,
  siteName,
) => {
  const fileDate = displayDate(Date.now(), 'LLL')
  const filename = `${program} Training Report for site ${siteName} as of ${fileDate}.csv`.trim()

  const headers = [
    { label: 'Activation Key', key: 'activationKey' },
    { label: 'Attempted', key: 'attempted' },
    { label: 'Is Completed', key: 'is_done' },
    { label: 'Completed At', key: 'doneAt' },
    { label: 'Is Open', key: 'is_open' },
    { label: 'Status', key: 'status' },
    { label: 'Program', key: 'skuCode' },
    { label: 'Learner', key: 'learner' },
    { label: 'Progress', key: 'progress' },
    { label: 'Score', key: 'score' },
    { label: 'Updated At', key: 'updatedAt' },
  ]

  const trainingReportDownloadData = {
    data: trainingData,
    headers: headers,
    filename,
  }
  return trainingReportDownloadData
}

const formatLessonReportData = lmsUser => {
  const { email, learner } = lmsUser || {}
  const {
    licenseStatus,
    updatedAt,
    className,
    grade,
    lessonsCompleted,
    lessonsTotal,
  } = lmsUser || {}
  const formattedEmail = email || NO_DATA_PLACEHOLDER
  const formattedName = learner || NO_DATA_PLACEHOLDER
  const formattedStatus = licenseStatus || NO_DATA_PLACEHOLDER
  const formattedClassName = className || NO_DATA_PLACEHOLDER
  const formattedGrade = grade?.toUpperCase() || NO_DATA_PLACEHOLDER
  const formattedUpdatedAt =
    (updatedAt && displayDate(updatedAt, DATE_FORMAT)) || NO_DATA_PLACEHOLDER
  const formattedTotalLessons = lessonsTotal || NO_DATA_PLACEHOLDER
  const formattedLessonsCompleted = lessonsTotal
    ? lessonsCompleted || 0
    : NO_DATA_PLACEHOLDER

  const formattedLessons = lessons => {
    const lessonObj = {}
    const safeLessons = Array.isArray(lessons) ? lessons : []
    for (let i = 0; i < TOTAL_LESSONS; i++) {
      lessonObj[`lesson${i + 1}`] =
        (safeLessons[i] && safeLessons[i].status) || NO_DATA_PLACEHOLDER
    }
    return lessonObj
  }

  return {
    email: formattedEmail,
    name: formattedName,
    licenseStatus: formattedStatus,
    className: formattedClassName,
    grade: formattedGrade,
    lessonsCompleted: formattedLessonsCompleted,
    totalLessons: formattedTotalLessons,
    updatedAt: formattedUpdatedAt,
    ...formattedLessons(lmsUser?.lessons),
  }
}

export const createLessonReportDownloadData = (
  lessonProgressData,
  licenseId,
  siteId,
  reportFilename = null,
  filetype = 'csv',
) => {
  const filename = `Lesson Progress Report for ${
    licenseId ? `license id ${licenseId}` : `site id ${siteId}`
  }${reportFilename ? ` for ${reportFilename}` : `.${filetype}`}`.trim()
  const formattedData = lessonProgressData
    ? lessonProgressData.map(lmsUser => formatLessonReportData(lmsUser))
    : []

  const createLessonKeys = () => {
    const lessonArray = []
    for (let i = 0; i < TOTAL_LESSONS; i++) {
      lessonArray.push({
        label: `Lesson ${i + 1}`,
        key: `lesson${i + 1}`,
      })
    }
    return lessonArray
  }

  const headers = [
    { label: 'Name', key: 'name' },
    { label: 'Email', key: 'email' },
    { label: 'User Status', key: 'licenseStatus' },
    { label: 'Class Name', key: 'className' },
    { label: 'Grade', key: 'grade' },
    { label: 'Most recent lesson viewed on', key: 'updatedAt' },
    { label: 'Lessons Completed', key: 'lessonsCompleted' },
    { label: 'Lessons in Grade', key: 'totalLessons' },
  ]
  const combinedHeaders = headers.concat(createLessonKeys())

  return {
    data: formattedData,
    headers: combinedHeaders,
    filename,
  }
}

export default { createLessonReportDownloadData, createTrainingReportDownloadData }
